import { decode } from 'punycode';
import { RootState, useAppSelector } from 'cache/store';
import { FormValuesLogin, LoginPayload } from 'models/authModel';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import styles from './login-header.style';
import { SubmitHandler, useForm } from 'react-hook-form';
import { DEVICE_INFO } from 'constants/common';
import { VERSION } from 'config/app.config';
import { colors } from 'constants/theme';
import Button from 'components/button/Button';
import LiveChatWidget from './LiveChatWidget';

interface Props {
    onLogin: (payload: LoginPayload, showAlertSuccess: boolean, closeModal: boolean, rememberAccount?: boolean) => void;
    onShowAuth: () => void;
}

function LoginHeader(props: Props) {
    const { onLogin, onShowAuth } = props;
    const { rememberData, isLogged } = useAppSelector((state: RootState) => state.auth);

    const [rememberAccount, setRememberAccount] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showChat, setShowChat] = useState(false);

    const { handleSubmit, register, setFocus, setValue } = useForm<FormValuesLogin>();

    useEffect(() => {
        if (rememberData && rememberData.isRemember && rememberData.account && !isLogged) {
            setValue('un', decode(rememberData.account).split('|')[0]);
            setValue('pwd', decode(rememberData.account).split('|')[1]);
            setRememberAccount(true);
        }
    }, [rememberData, isLogged, setValue]);

    const handleLoginForm: SubmitHandler<FormValuesLogin> = async (values) => {
        const { un, pwd } = values;
        if (!un.toLowerCase().trim) {
            setFocus('un');
            toast.error('Vui lòng nhập tài khoản !');
            return;
        }
        if (!pwd) {
            setFocus('pwd');
            toast.error('Vui lòng nhập mật khẩu !');
            return;
        }

        const payload = {
            un,
            pwd,
            ver: VERSION,
            di: DEVICE_INFO,
        };
        onLogin(payload, true, false, rememberAccount);
    };

    const getLiveChat = () => {
        const LC_API: any = window['LC_API' as any];
        if (LC_API) {
            LC_API.open_chat_window();
        }
    };

    return (
        <form className={styles.right} onSubmit={handleSubmit(handleLoginForm)}>
            <div className={styles.bgForm}>
                <div className={styles.formLogin}>
                    <div className={styles.inputWrap}>
                        <div className={styles.inputlog}>
                            <img className={styles.icon} src={require('assets/images/icons/user_input.png')} alt="" />
                            <input {...register('un')} className={styles.input} type="text" placeholder="Tên Đăng Nhập" />
                            <div className={styles.remember}>
                                <input onChange={(e) => setRememberAccount(e.target.checked)} checked={rememberAccount} id="remember" type="checkbox" />
                                <label htmlFor="remember">Ghi nhớ</label>
                            </div>
                        </div>
                    </div>
                    <div className={styles.inputWrap}>
                        <div className={styles.inputlog}>
                            <img className={styles.icon} src={require('assets/images/icons/pw_input.png')} alt="" />
                            <input {...register('pwd')} className={styles.input} type={showPass ? 'text' : 'password'} placeholder="Mật khẩu" />
                            <button type="button" className={styles.togglePw} onClick={() => setShowPass(!showPass)}>
                                {showPass ? <img src={require('assets/images/icons/eye_on.png')} alt="" /> : <img src={require('assets/images/icons/eye_off.png')} alt="" />}
                            </button>
                        </div>
                    </div>
                    <div className={styles.inputWrap}>
                        <button type="button" className={styles.forgetPw} onClick={getLiveChat}>
                            {/* <span>
                                Quên mật khẩu hoặc <br></br> tên đăng nhập?
                            </span> */}
                            <LiveChatWidget license='12548625' visibility='maximized' onShowChat={showChat} />
                        </button>
                    </div>
                </div>
            </div>
            <div className={styles.btnGroup}>
                <Button text="Đăng Nhập" bg={colors.secondary} borderColor="none" minWidth="112px" typeButton="submit" />
                <Button text="Đăng Ký" bg="none" click={onShowAuth} borderColor="#005a41" minWidth="112px" />
            </div>
        </form>
    );
}

export default LoginHeader;
